import { render } from "./ProductCardComponent.vue?vue&type=template&id=53af78c6"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"

import "./ProductCardComponent.vue?vue&type=style&index=0&id=53af78c6&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__